import React, { Component, ReactDOM, createRef } from 'react'
import { Image, Button, Badge, Spinner } from 'react-bootstrap';
import * as G from '../components/global'
import { renderPageContainer, renderPageHeader, renderDivider, getData } from '../components/global'
import history from '../components/history';
import { connect } from 'react-redux';
import MessageBox from '../components/MessageBox';
import emailtempl from '../components/assets/emailtempl.png'
import { translateScreen as ts , translateDate as td, translateScreen2 as ts2} from '../components/dictionary'
import ReactPaginate from 'react-paginate';
import 'rsuite/dist/rsuite.min.css';
import {DateRangePicker, DatePicker} from 'rsuite';
import qs from 'qs'
import Select from 'react-select'
import chroma from 'chroma'
import dateFormat from 'dateformat';
class Gifts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeScreen: 0,
            activeGifts: [],
			expiredGifts:[],
			disabledGifts:[],
			giftCategoryOptions:[],
			giftCategory:[],
            giftCategoryNames:[],
            imagelink:'',
            selectedFile:null,
			stats:{},
			giftId:-1,
            selectedGift:null,
            loadingGifts: true,
			languagesList:[],
			errors:{'tokensvalue':"",'startdate':"",'enddate':"",'status':"",'limitpergift':""},
			fields:{},
            searchfields:{},
            giftRedeems:[],
            customersloading:false,
            modalShow: false,
            modalGiftShow:false,
            redeemModalShow: false,
            giftResultModalShow:false,
            giftresult:'',
            modalBody: '',
            modalSubject: '',
            selectedRedemption:{},
            redeemCustomerid:null,
            showRedeemButton:false,
            fieldchanging:false,
            successmodalShow:false
        }
		this.handleChange = this.handleChange.bind(this);
        this.handleLanguageChange = this.handleLanguageChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
		this.handleDateChange = this.handleDateChange.bind(this);
		this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleStatusSearch = this.handleStatusSearch.bind(this);
        
        this.imagechangeHandler = this.imagechangeHandler.bind(this);
        this.onBlur = this.onBlur.bind(this);
    }
    
    async componentDidMount() {
		this.selectInputRef = createRef();
		
        if (this.props.userLogin.site){
            this.getcategories();
            this.refreshData(this.props.userLogin.site.id)
        }
        history.listen((location, action) => {
            if(location.pathname == "/Gifts" || location.pathname == "/Gifts/")
            {
		        this.setState({activeScreen:0, fields:{}});
	        }
          });
        // if (this.state.allCompanies.length === 0) {
        //refreshDataClients()
        // }
    }
    getSnapshotBeforeUpdate(prevProps) {
        var searchfield = document.getElementById("searchfield");
            if(searchfield!=undefined && searchfield.value !="")
            {
                var nodes = document.getElementsByClassName('templatecard');
           Array.prototype.map.call(nodes, (elem)=>{
            if (elem.innerText.toLowerCase().includes(searchfield.value)) {
                elem.style.display = "block";
            } else {
                elem.style.display = "none";
            }
        });
            }
        return { notifyRequired: prevProps.userLogin !== this.props.userLogin };
      }
      imagechangeHandler(event) {
        var file = event.target.files[0];
        let reader = new FileReader();
    reader.onload = (e) => {
      this.setState({imagelink: e.target.result});
    };
    reader.readAsDataURL(file);
        
        this.setState({selectedFile:file});
	}
      async componentDidUpdate(prevProps, prevState, snapshot) {
        if (snapshot.notifyRequired) {
            this.getcategories();
            await this.refreshData(this.props.userLogin.site.id);
        }
        
      }
    refreshData = async (company) => {
		this.setState({ loadingGifts: true })
        let { searchfields } = this.state;
        let upcomingfilter = '', activefilter = '', expiredfilter = '', redeemedfilter = '', disabledfilter = '';
        if(searchfields['searchrange']!= undefined && searchfields['searchrange']!=null)
        {
            var range = searchfields['searchrange'];
            var startdate = new Date(range[0])
            var enddate = new Date(range[1])
            var starts = td(dateFormat(startdate,"yyyy-mm-dd"));
            var ends = td(dateFormat(enddate,"yyyy-mm-dd"))
            var datefilter = `and (a.startdate is null or (DATEDIFF(a.startdate,'`+starts + `') >= 0 and DATEDIFF(a.startdate,'`+ends + `') <= 0) or a.enddate is null or (DATEDIFF(a.enddate,'`+starts + `') >= 0 and DATEDIFF(a.enddate,'`+ends + `') <= 0) )`
            activefilter += datefilter;//` and (a.startdate is null or (DATEDIFF(a.startdate,'`+starts + `') >= 0 and DATEDIFF(a.startdate,'`+ends + `') <= 0) or a.enddate is null or (DATEDIFF(a.enddate,'`+starts + `') >= 0 and DATEDIFF(a.enddate,'`+ends + `') <= 0) )`
            expiredfilter +=` and ((DATEDIFF(a.startdate,'`+starts + `') >= 0 and DATEDIFF(a.startdate,'`+ends + `') <= 0) or (DATEDIFF(a.enddate,'`+starts + `') >= 0 and DATEDIFF(a.enddate,'`+ends + `') <= 0))`
            upcomingfilter +=` and ((DATEDIFF(a.startdate,'`+starts + `') >= 0 and DATEDIFF(a.startdate,'`+ends + `') <= 0) or (DATEDIFF(a.enddate,'`+starts + `') >= 0 and DATEDIFF(a.enddate,'`+ends + `') <= 0))`
            redeemedfilter += ` and DATEDIFF(datein,'`+starts + `') >= 0 and DATEDIFF(datein,'`+ends + `') <= 0`
            disabledfilter += datefilter;//` and ((DATEDIFF(a.startdate,'`+starts + `') >= 0 and DATEDIFF(a.startdate,'`+ends + `') <= 0) or (DATEDIFF(a.enddate,'`+starts + `') >= 0 and DATEDIFF(a.enddate,'`+ends + `') <= 0))`
        }
        if(searchfields['category'])
        {
            var categories = searchfields['category'];
            var s = "";
            categories.map(elem=>{
                s += "," + elem.value
            })
            if(s!="")
            {
                s = s.substring(1);
                activefilter += " and a.id in (select giftid from giftcategoryrelation where categoryid in ("+s+"))"
                expiredfilter += " and a.id in (select giftid from giftcategoryrelation where categoryid in ("+s+"))"
                upcomingfilter += " and a.id in (select giftid from giftcategoryrelation where categoryid in ("+s+"))"
                redeemedfilter += " and giftid in (select giftid from giftcategoryrelation where categoryid in ("+s+"))"
                disabledfilter += " and a.id in (select giftid from giftcategoryrelation where categoryid in ("+s+"))"
            }
        }
        if(searchfields["searchname"])
        {
            var name = searchfields["searchname"];
            if(name!="")
            {
            activefilter += " and a.name like '%"+name+"%'"
            expiredfilter += " and a.name like '%"+name+"%'"            
            upcomingfilter += " and a.name like '%"+name+"%'"
            disabledfilter += " and a.name like '%"+name+"%'"
            }
        }
        var active = [], expired = [], disabled = [], stats = [];
        if(searchfields["giftstatus"])
        {
            var status = searchfields["giftstatus"];
            switch(status)
            {
                case "All":
                    active = await getData('gifts/get', [['filter', 'a.siteid = ' + company + " and (a.enddate>=now() or a.enddate is null) and a.enabled=1 " + activefilter]]);
                    active = await active.data;
                    expired = await getData('gifts/get', [['filter', 'a.siteid = ' + company + " and a.enddate<now()" + expiredfilter]]);
                    expired = await expired.data;
                    disabled = await getData('gifts/get', [['filter', 'a.siteid = ' + company + " and a.enabled<>1"]]);
                    disabled = await disabled.data;
                    break;
                case "Upcoming":
                    active = await getData('gifts/get', [['filter', 'a.siteid = ' + company + " and a.startdate>=now() and a.enabled=1 " + activefilter]]);
                    active = await active.data;
                    break;
                case "Active":
                    active = await getData('gifts/get', [['filter', 'a.siteid = ' + company + " and ((a.startdate<=now() and a.enddate>=now()) or a.startdate is null or a.enddate is null) and a.enabled=1 " + activefilter]]);
                    active = await active.data;
                    break;
                case "Expired":
                    expired = await getData('gifts/get', [['filter', 'a.siteid = ' + company + " and a.enddate<now() " + expiredfilter]]);
                    expired = await expired.data;
                    break;
                case "Disabled":
                    disabled = await getData('gifts/get', [['filter', 'a.siteid = ' + company + " and a.enabled<>1 " + disabledfilter]]);
                    disabled = await disabled.data;
                    break;
                default:
                    
                    break;
            }
        }
        else{
            active = await getData('gifts/get', [['filter', 'a.siteid = ' + company + " and (a.enddate>=now() or a.enddate is null) and a.enabled=1 " + activefilter]]);
                    active = await active.data;
                    expired = await getData('gifts/get', [['filter', 'a.siteid = ' + company + " and a.enddate<now() " + expiredfilter]]);
                    expired = await expired.data;
                    disabled = await getData('gifts/get', [['filter', 'a.siteid = ' + company + " and a.enabled<>1 " + disabledfilter]]);
                    disabled = await disabled.data;
        }
       
		stats = await getData('gifts/stats', [['siteid', company], ['redeemedfilter', redeemedfilter], ['upcomingfilter', ' and startdate>=now() and enabled=1' + upcomingfilter],
         ['activefilter', ' and (enddate>=now() or enddate is null) and enabled=1 ' + activefilter],['expiredfilter',' and enddate<now() ' + expiredfilter]]);
        stats = await stats.data;
        this.setState({ activeGifts: active, expiredGifts: expired, disabledGifts: disabled, stats: stats })
        this.setState({ loadingGifts: false })
        
        var isduplicate = qs.parse(history.location.search, { ignoreQueryPrefix: true }).isduplicate
        var detailid = qs.parse(history.location.search, { ignoreQueryPrefix: true }).detailid
        var editid = qs.parse(history.location.search, { ignoreQueryPrefix: true }).editid
        active.map(el=>{
            if(el.id == detailid)
            {
                this.OpenDetails(el.id, el, false);
            }
            else if(el.id == editid)
            {
                this.OpenEdit((isduplicate == '1'?'-1':el.id), el, false);
            }
        })
        expired.map(el=>{
            if(el.id == detailid)
            {
                this.OpenDetails(el.id, el, false);
            }
            else if(el.id == editid)
            {
                this.OpenEdit((isduplicate == '1'?'-1':el.id), el, false);
            }
        })
        disabled.map(el=>{
            if(el.id == detailid)
            {
                this.OpenDetails(el.id, el, false);
            }
            else if(el.id == editid)
            {
                this.OpenEdit((isduplicate == '1'?'-1':el.id), el, false);
            }
        })
    }
    handleStatusSearch = (e)=>
    {
        let { searchfields } = this.state;
        searchfields["giftstatus"] = e.target.value;
		 this.setState({ searchfields });
         this.refreshData(this.props.userLogin.site.id);
    }
    handleClickStatusSearch = (val)=>
    {
        let { searchfields } = this.state;
        searchfields["giftstatus"] = val;
		 this.setState({ searchfields });
         this.refreshData(this.props.userLogin.site.id);
    }
    handleCategorySearch = (name, e)=>{
        let { searchfields } = this.state;
        searchfields[name] = e;
		 this.setState({ searchfields });
         this.refreshData(this.props.userLogin.site.id);
    }
    handleSearchKeyUp = (e)=>{
        let { searchfields } = this.state;
        searchfields["searchname"] = e.target.value;
		 this.setState({ searchfields });
         this.refreshData(this.props.userLogin.site.id);
     }
     handleDateRangeChange = async(range)=>{
        let { searchfields } = this.state;
        searchfields["searchrange"] = range;
		 this.setState({ searchfields });
        this.refreshData(this.props.userLogin.site.id)
        
    }
	getlanguages = async()=>{
		let array = [];
		array = await G.getData("languages/query",[["filter"," 1=1 order by orderindex"]]);
		array = await array.data;
		this.setState({languagesList: array});
	}
	getcategories = async (company) => {
        if(this.selectInputRef.current!=null)
            this.selectInputRef.current.select.clearValue();
        let array = []
        array = await G.getData("giftcategory/query", [["filter","a.siteid=" + this.props.userLogin.site.id]])
        array = await array.data
        this.setState({ giftCategory: array })
        let arrayNames = [];
        array.map(element => {
          arrayNames.push(element.name)
        })
        this.setState({ giftCategoryNames: arrayNames })
        console.log(this.state.giftCategory)
        const categoryOptions = [];
        array.map(element => {
          categoryOptions.push({value:element.id, label:element.name});
        })
        this.setState({ giftCategoryOptions: categoryOptions })
      }
      OpenCreate = ()=>{
        this.setState({imagelink:''})
        this.getlanguages().then(()=>{
            this.setState({activeScreen:1});history.push('/Gifts/create')
            this.state.languagesList && this.state.languagesList.map(el=>{
                this.state.fields[el.id + '_name'] = '';
                this.state.fields[el.id + '_description'] = '';
                this.state.errors[el.id + '_name'] = '';
                this.state.errors[el.id + '_description'] = '';
                this.setState({fields:this.state.fields, errors: this.state.errors});
            })   ;
            this.setState({fields:this.state.fields, errors: this.state.errors}); 
        });
        
      }
      OpenEdit = async (id, element, redirect = true)=>
    {
        this.getlanguages();
   
        var starts = element.startdate?td(dateFormat(element.startdate,"yyyy-mm-dd")):'';
        var ends = element.enddate?td(dateFormat(element.enddate,"yyyy-mm-dd")):'';
            var dbcats = [];
                var result = await G.getData("giftcategory/query",[["filter"," id in (select categoryid from giftcategoryrelation where giftid ="+element.id+")"]]);
                result = await result.data;
                result.map(elem=>{
                    dbcats.push({value:elem.id, label:elem.name})
                })
        var langresult = await G.getData("gifttranslation/query",[["filter","giftid=" + element.id]]);
        langresult = await langresult.data;
        
        this.setState({giftId:id, selectedGift:element, fields:{category:dbcats, startdate: starts, enddate: ends,tokensvalue: element.tokensvalue,limitpergift: element.limitpergift, enabled: element.enabled, code:element.code},errors:{}});
        var {fields} = this.state;
        langresult.map(rec=>{
            fields[rec.languageid + "_name"] = rec.name;
            fields[rec.languageid + "_description"] = rec.description;
        })
        this.setState({ fields, activeScreen:1,imagelink:G.nodeServerSite+"mediaFiles/giftsimage/" + element.image });
        if(redirect == true)
            history.push("/Gifts/edit?editid=" + element.id+"&isduplicate=" + (id == '-1'?'1':'0'))
    }
	OpenDetails = async(id, element, redirect = true)=>{
        this.setState({ customersloading: true })
        var dbcats = [];
                var result = await G.getData("giftcategory/query",[["filter"," id in (select categoryid from giftcategoryrelation where giftid ="+element.id+")"]]);
                result = await result.data;
                result.map(elem=>{
                    dbcats.push(elem.name)
                })
                var redeems = await G.getData("customergifts/get",[["filter","cg.giftid=" + id]])
                redeems = await redeems.data;
                
        this.setState({activeScreen:2, selectedGift:element, giftCategory:dbcats, giftRedeems:redeems});
        if(redirect == true)
            history.push("/Gifts/details?detailid=" + id)
           if(this.state.giftRedeems)
           {
            this.loadDataTables();
           } 
        
    }  
    loadDataTables = ()=>{
       var _this = this;
		setTimeout(() => {
            try{
            document.removeChild(document.querySelector("#dttablestats"));
            }
            catch{}
                    const script = document.createElement("script");
                script.id = "dttablestats";
                script.src = '/dist/js/gifttable.js';
                script.async = true;
                document.body.appendChild(script);
                
                _this.setState({ customersloading: false })
        }, 100);
        
}
    
    
    renderActiveButton = (id, element, cats) => {
		
        return (
        <div className="col-md-3 templatecard" onClick={(event)=>{if(event.target.className!='fa fa-ellipsis-v' && event.target.className!='dropdown-item')this.OpenDetails(id, element)}}>
            <div className="info-box handCursor shadow-sm" style={{backgroundColor:"#3FCAE0", color:"white"}}>
              {/*<span className="info-box-icon bg-info" style={{padding:"30px"}} onClick={() => { this.openCampaignEditor(id, element) }}><i className="far fa-envelope"></i></span>*/}
              <div className="info-box-content">
                <div className='info-icon' ><i className="fa fa-ellipsis-v" style={{padding:"5px 10px"}} data-toggle="dropdown" href="#" aria-expanded="false"></i>
                <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                    <a onClick={()=>{this.OpenEdit(-1,element)}} className="dropdown-item">
                    {ts2("Duplicate",this.props.userLogin.language)}
                    </a>
                    <div className="dropdown-divider"></div>
                    <a onClick={()=>{this.OpenEdit(element.id,element)}} className="dropdown-item">
                    {ts('Edit', this.props.userLogin.language)}
                    </a>
					<div className="dropdown-divider"></div>
                    <a onClick={()=>{this.DisableGift(id)}} className="dropdown-item">
                    {ts('Disable', this.props.userLogin.language)}
                    </a>
                </div>
                </div>
				<h3>{element.usage}<br/></h3>
				<small>usage</small>
                <span className="info-box-text bold" style={{width:"70%"}} >{element.name}</span>
                <span className="info-box-text" style={{width:"70%"}}>{element.category}</span>
                <span className="info-box-number" style={{fontStyle:"italic"}} > {element.startdate ? td(dateFormat(element.startdate, 'mmm dd, yyyy'),this.props.userLogin.language) : <>&nbsp;</>}  {element.enddate ?"till " + td(dateFormat(element.enddate, 'mmm dd, yyyy'),this.props.userLogin.language) : <>&nbsp;</>}</span>
              </div>
            </div>
        </div>
        )
    }
	renderExpiredButton = (id, element, cats) => {
		
        return (
        <div className="col-md-3 templatecard" onClick={(event)=>{if(event.target.className!='fa fa-ellipsis-v' && event.target.className!='dropdown-item')this.OpenDetails(id, element)}}>
            <div className="info-box  handCursor shadow-sm" style={{backgroundColor:"#8CB6CC", color:"white"}}>
              {/*<span className="info-box-icon bg-info" style={{padding:"30px"}} onClick={() => { this.openCampaignEditor(id, element) }}><i className="far fa-envelope"></i></span>*/}
              <div className="info-box-content">
                <div className='info-icon'><i className="fa fa-ellipsis-v" style={{padding:"5px 10px"}} data-toggle="dropdown" href="#" aria-expanded="false"></i>
                <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                    <a onClick={()=>{this.OpenEdit(-1,element)}} className="dropdown-item">
                    {ts2("Duplicate",this.props.userLogin.language)}
                    </a>
                    <div className="dropdown-divider"></div>
                    <a onClick={()=>{this.OpenEdit(element.id,element)}} className="dropdown-item">
                    {ts('Edit', this.props.userLogin.language)}
                    </a>
                </div>
                </div>
				<h3>{element.usage}<br/></h3>
				<small>usage</small>
                <span className="info-box-text bold" style={{width:"70%"}}>{element.name}</span>
                <span className="info-box-text" style={{width:"70%"}}>{element.category}</span>
                <span className="info-box-number" style={{fontStyle:"italic"}}> {element.startdate !== '' ? td(dateFormat(element.startdate, 'mmm dd, yyyy'),this.props.userLogin.language) : ''} till {element.enddate !== '' ? td(dateFormat(element.enddate, 'mmm dd, yyyy'),this.props.userLogin.language) : ''}</span>
              </div>
            </div>
        </div>
        )
    }
    renderDisabledButton = (id, element, cats) => {
		
        return (
        <div className="col-md-3 templatecard" onClick={(event)=>{if(event.target.className!='fa fa-ellipsis-v' && event.target.className!='dropdown-item')this.OpenDetails(id, element)}}>
            <div className="info-box  handCursor shadow-sm" style={{backgroundColor:"#B9C0C9", color:"white"}}>
              {/*<span className="info-box-icon bg-info" style={{padding:"30px"}} onClick={() => { this.openCampaignEditor(id, element) }}><i className="far fa-envelope"></i></span>*/}
              <div className="info-box-content">
                <div className='info-icon'><i className="fa fa-ellipsis-v" style={{padding:"5px 10px"}} data-toggle="dropdown" href="#" aria-expanded="false"></i>
                <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                    <a onClick={()=>{this.OpenEdit(-1,element)}} className="dropdown-item">
                    {ts2("Duplicate",this.props.userLogin.language)}
                    </a>
                    <div className="dropdown-divider"></div>
                    <a onClick={()=>{this.OpenEdit(element.id,element)}} className="dropdown-item">
                    {ts('Edit', this.props.userLogin.language)}
                    </a>
                </div>
                </div>
				<h3>{element.usage}<br/></h3>
				<small>usage</small>
                <span className="info-box-text bold" style={{width:"70%"}}>{element.name}</span>
                <span className="info-box-text" style={{width:"70%"}}>{element.category}</span>
                <span className="info-box-number" style={{fontStyle:"italic"}}> {element.startdate !== '' ? td(dateFormat(element.startdate, 'mmm dd, yyyy'),this.props.userLogin.language) : ''} till {element.enddate !== '' ? td(dateFormat(element.enddate, 'mmm dd, yyyy'),this.props.userLogin.language) : ''}</span>
              </div>
            </div>
        </div>
        )
    }
    /*EnableGift = async(id)=>{
        await getData('gifts/enable',[['id',id]]);
        this.refreshArchivedData(this.props.userLogin.site.id);
        this.refreshData(this.props.userLogin.site.id);
    }*/
    DisableGift = async(id)=>{
        await getData('gifts/disable',[['id',id]]);
        this.refreshData(this.props.userLogin.site.id);
    }
    onBlur(e){
        this.setState({fieldchanging:false});
    }
    handleLanguageChange(e) {
		let { fields, errors,languagesList } = this.state;
		 fields[e.target.name] = e.target.value;
		 delete errors[e.target.name];

         for(var i=0;i<languagesList.length;i++)
         {
             var elem = languagesList[i];
             
             if(e.target.name.includes('_name'))
             {
                if(!fields[elem.id + "_name"] || fields[elem.id + "_name"]=='' || this.state.fieldchanging)
                {
                fields[elem.id + "_name"] = e.target.value;
                delete errors[elem.id + "_name"];
                this.setState({fieldchanging:true});
                }
             }
             if(e.target.name.includes('_description'))
             {
                if(!fields[elem.id + "_description"] || fields[elem.id + "_description"]=='' || this.state.fieldchanging)
                {
                    fields[elem.id + "_description"] = e.target.value;
                    document.getElementById(elem.id + "_description").value = e.target.value;
                    delete errors[elem.id + "_description"];
                    this.setState({fieldchanging:true});
                }
             }
         }
		 this.setState({ fields });
	 }
	handleChange(e) {
		let { fields, errors } = this.state;
		 fields[e.target.name] = e.target.value;
		 delete errors[e.target.name];
		 this.setState({ fields });
	 }
	 handleDateChange(name, date){
        let { fields, errors } = this.state;
        if(date)
        {
		var d = new Date(date)
		var dates = td(dateFormat(d,"yyyy-mm-dd"));
		
		fields[name] = dates;
		delete errors[name];
		this.setState({ fields });
        }
        else{
            delete fields[name];
        }
	 }
	 handleSelectChange(name, e){
		let { fields, errors } = this.state;
		fields[name] = e;
		delete errors[name];
		console.log("fields",fields);
		console.log("field e",e);
		this.setState({ fields });
	 }
	 createGift = async(giftId)=>{
         var {errors} = this.state;
		const { category, startdate, enddate,tokensvalue,limitpergift, enabled, code } = this.state.fields;
		var status = enabled;
		
		var translation = [];
        var valid = true;
        /*if(tokensvalue==undefined || tokensvalue == '')
        {
            valid = false;
            errors["tokensvalue"] = "This field is required";
        }*/
        /*if(startdate==undefined || startdate == '')
        {
            valid = false;
            errors["startdate"] = "This field is required";
        }
        if(enddate==undefined || enddate == '')
        {
            valid = false;
            errors["enddate"] = "This field is required";
        }*/
        if(enddate != undefined && enddate != null && enddate !='' && startdate != undefined && startdate != null && startdate !='')
        {
            var date1 = new Date(startdate);
            var date2 = new Date(enddate);
            if(date2<=date1)
            {
                errors["enddate"] = "End date should be newer then start date";
                errors["startdate"] = "Start date should be older then end date";
                valid = false;
            }
        }
        if(status==undefined || status == '')
        {
            valid = false;
            errors["enabled"] = "This field is required";
        }
        /*if(limitpergift==undefined || limitpergift == '')
        {
            valid = false;
            errors["limitpergift"] = "This field is required";
        }*/
        if(category == undefined || category.length == 0)
        {
            valid = false;
            errors["category"] = "This field is required";
        }
        /*if(code == undefined || code == '')
        {
            valid = false;
            errors["code"] = "This field is required";
        }*/
		var params = [["giftId",giftId],["siteid",this.props.userLogin.site.id],["tokensvalue", tokensvalue],
		["enabled", status], ["category", JSON.stringify(category)], ["startdate", startdate], ["enddate", enddate], ["limitpergift", limitpergift], ["code", code]];
        var giftname = "";
		this.state.languagesList.map((elem)=>{
			var name = this.state.fields[elem.id + "_name"];
			var description =  this.state.fields[elem.id + "_description"];
			translation.push({langid: elem.id, name:name, description: description});
			//["name", translation[0].name],["description", translation[0].description],
            if(name == undefined || name=='')
            {
                errors[elem.id+"_name"] = "This field is required";
                valid = false;
            }
            if(description == undefined || description == '')
            {
                errors[elem.id+"_description"] = "This field is required";
                valid = false;
            }
			if(elem.code == "en")
			{
                giftname = name;
				params.push(["name", name])
				params.push(["description", description])
			}
			params.push(["name_"+elem.code, name])
			params.push(["description_"+elem.code, description])
            
		});
        params.push(['image' ,this.state.selectedFile]);
        if(valid)
        {
		var result = await G.uploadData("gifts/upload",params)
		let success = (result.status === 200)
            if (success) {
                if(giftId === -1)
                {
                    var logtxt = this.props.userLogin.username + " has created a gift " + giftname;
                    await G.SaveUserLog(logtxt, this.props.userLogin.id);
                }
                else{
                    var logtxt = this.props.userLogin.username + " has edited the gift info of " + giftname;
                    await G.SaveUserLog(logtxt, this.props.userLogin.id);
                }
                this.setState({ activeScreen: 0, fields: {}, selectedFile:null, imagelink:'', successmodalShow: giftId !== -1})
                this.refreshData(this.props.userLogin.site.id)
                history.push("/Gifts")
            }
        }
        else{
            this.setState({errors:this.state.errors});
        }
	 }
     OpenRedeem = ()=>{
        this.setState({redeemModalShow: true})
     }
     openModal = async(showbutton = false)=>{
         var item = this.state.selectedRedemption;
         var result = await G.getData("customertokens/query",[["filter","customerid=" + this.state.selectedRedemption.customerid]])
    result = await result.data;
    var score = 0;
    result.map(el=>score += el.score);
    item.tokens = score;
        this.setState({
            modalShow: true,
            selectedRedemption: item,
            showRedeemButton: showbutton
        })
     }
     redeemGift = async()=>{
        console.log("SelectedREdemption",this.state.selectedRedemption )
        var result = await G.getData("redeemgiftbycode",[["code",this.state.selectedRedemption.code], ["customerid",this.state.selectedRedemption.customerid], ["siteid",this.props.userLogin.site.id], ["adminid",this.props.userLogin.id]]);
                                        result = await result.data;
                                        if(result.response == "success")
                                        {
                                            this.setState({ modalGiftShow: false });
                                var logtxt = this.props.userLogin.username + " has redeemed " + result.gift.name + " gift for the customer " +  this.state.selectedRedemption.firstName + " " + this.state.selectedRedemption.lastName+ "(" + this.state.selectedRedemption.emailAddress + ")";
                    await G.SaveUserLog(logtxt, this.props.userLogin.id);
                                //this.getGiftsPerCustomer();
                                
                                            this.OpenDetails(this.state.selectedRedemption.id, this.state.selectedRedemption)
                                            //show gift details
                                        }
                                        else{
                                            if(result.response == "notavailable")
                                            {
                                                this.setState({modalGiftShow:false, giftresult:ts2("this gift is not available for this customer", this.props.userLogin.lanauge), giftResultModalShow:true});
                                            }
                                            else if(result.response == "notfound"){
                                                this.setState({modalGiftShow:false, giftresult:ts2("Code not found", this.props.userLogin.lanauge), giftResultModalShow:true})
                                            }
                                        }
     }
     showRedeemedGift = async(gift)=>{
        this.setState({
            selectedRedemption: gift,
            modalSubject: "Redeem Gift"
        })
        var item = this.state.selectedRedemption;
         var result = await G.getData("customertokens/query",[["filter","customerid=" + this.state.selectedRedemption.customerid]])
    result = await result.data;
    var customer = await G.getData("profile/query",[["filter","id=" + gift.customerid]]);
    var alerts = await G.getData("customeralerts/query",[["filter","customerid=" + gift.customerid + " and status=1"]]);
    alerts = await alerts.data;
    customer = await customer.data;
    item.firstName = customer[0].firstName;
    item.lastName = customer[0].lastName;
    item.emailAddress = customer[0].emailAddress;
    item.customeralerts = alerts;
    var redeems = await G.getData("customergifts/get",[["filter","cg.giftid=" + customer[0].id]])
                redeems = await redeems.data;
    var score = 0;
    result.map(el=>score += el.score);
    var dbcats = [];
                var result = await G.getData("giftcategory/query",[["filter"," id in (select categoryid from giftcategoryrelation where giftid ="+item.id+")"]]);
                result = await result.data;
                result.map(elem=>{
                    dbcats.push(elem.name)
                })
    item.tokens = score;
        this.setState({
            giftCategory:dbcats,
            giftRedeems: redeems,
            modalGiftShow: true,
            selectedRedemption: item,
            showRedeemButton: true
        })
    }
	 render() {
		const { errors, fields } = this.state;
        /*if (this.state.allCompanies != null) {

            if (this.state.allCompanies.length === 0) { this.refreshDataClients(); }

        }*/
        return (
            <>
                {/*<section className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h1>{ts('Email templates',this.props.userLogin.language)}</h1>
                            </div>
                        </div>
                    </div>
        </section>*/}
                
                
                {this.state.activeScreen === 0 &&

                    renderPageContainer(
                        <>
                        <section className='content'>                
                            
                            
                            <div className='row'><div className='col-sm-6'><Button onClick={() => { this.OpenCreate()  }} variant='success' className='mt-5 mb-4' >{ts('Create New Gift',this.props.userLogin.language)}</Button>&nbsp;&nbsp;
                            <Button onClick={() => { this.OpenRedeem()  }} variant='primary' className='mt-5 mb-4' >{ts('Redeem Gift',this.props.userLogin.language)}</Button>
                            </div></div>
                            
							<h3>{ts('Gifts',this.props.userLogin.language)}&nbsp;&nbsp;
                             <DateRangePicker onChange={(value)=>{this.handleDateRangeChange(value)}}  placeholder={ts("Filter by date range", this.props.userLogin.language)} />
                            </h3><div className="col-md-12" style={{height:"20px"}}></div>
                            <div className="row">
                                <div className="col-md-2">
                                <div className="info-box handCursor" style={{padding:"15px 5px"}}  onClick={()=>{this.handleClickStatusSearch("")}}>
                                <div className="info-box-content">
                                <span style={{color:"black"}}>{ts("Total redeemed", this.props.userLogin.language)}</span>
                                    <span style={{fontSize:"40px", color:"black"}}>{this.state.stats.redeemed}</span>
                        
                                </div>
                                    
                                    </div>
                                    
                                </div>
                                <div className="col-md-2">
                                <div className="info-box handCursor mainScreenCard" onClick={()=>{this.handleClickStatusSearch("Upcoming")}}>
                                <div className="info-box-content">
                                <span style={{color:"black"}}>{ts("Upcoming", this.props.userLogin.language)}</span>
                                    <span style={{fontSize:"40px", color:"#2A72CC"}}>{this.state.stats.upcoming}</span>
                        
                                </div>
                                    
                                    </div>
                                
                                </div>
                                <div className="col-md-2">
                                <div className="info-box handCursor mainScreenCard" onClick={()=>{this.handleClickStatusSearch("Active")}}>
                                <div className="info-box-content">
                                <span style={{color:"black"}}>{ts("Active", this.props.userLogin.language)}</span>
                                    <span style={{fontSize:"40px", color:"#3FCAE0"}}>{this.state.stats.active}</span>
                        
                                </div>
                                    
                                    </div>
                                
                                </div>
                                <div className="col-md-2">
                                <div className="info-box handCursor mainScreenCard" onClick={()=>{this.handleClickStatusSearch("Expired")}}>
                                <div className="info-box-content">
                                <span style={{color:"black"}}>{ts("Expired", this.props.userLogin.language)}</span>
                                    <span style={{fontSize:"40px", color:"#8CB6CC"}}>{this.state.stats.expired}</span>
                        
                                </div>
                                    
                                    </div>
                                
                                </div>
                                <div className="col-md-2">
                                <div className="info-box handCursor mainScreenCard" onClick={()=>{this.handleClickStatusSearch("Disabled")}}>
                                <div className="info-box-content">
                                <span style={{color:"black"}}>{ts("Disabled", this.props.userLogin.language)}</span>
                                    <span style={{fontSize:"40px", color:"#8D949D"}}>{this.state.stats.disabled}</span>
                        
                                </div>
                                    
                                    </div>
                                
                                </div>
                            </div>
                            <div className="col-md-12" style={{height:"10px"}}></div>
							<div className="row">
								<div className='form-group col-md-3'>
								<label for="searchfield">Select gift status</label>
								<select className='custom-select' id="statussearch" onChange={this.handleStatusSearch}>
                                    {this.state.searchfields["giftstatus"]=="All"?<option selected>All</option>:<option>All</option>}
									{this.state.searchfields["giftstatus"]=="Upcoming"?<option selected>Upcoming</option>:<option>Upcoming</option>}
                                    {this.state.searchfields["giftstatus"]=="Active"?<option selected>Active</option>:<option>Active</option>}
                                    {this.state.searchfields["giftstatus"]=="Expired"?<option selected>Expired</option>:<option>Expired</option>}
                                    {this.state.searchfields["giftstatus"]=="Disabled"?<option selected>Disabled</option>:<option>Disabled</option>}
								</select>
								</div>
								<div className='form-group col-md-3'>
								<label>Filter by gift category</label>
								<Select ref={this.selectInputRef} menuPortalTarget={document.body} isClearable={true}
            onChange={(e)=>this.handleCategorySearch("category", e)}
    closeMenuOnSelect={false}
    isMulti    
    styles={colourStyles}
    options={this.state.giftCategoryOptions}
  />
								</div>
                            <div className="form-group col-md-3">
                            <label for="searchfield">Search</label>
                            <div class="input-group">
                                
                  <input id="searchfield" type="text" class="form-control" onKeyUp={(e)=>this.handleSearchKeyUp(e)}/>
                  <div class="input-group-append">
                    <span class="input-group-text"><i class="fas fa-search"></i></span>
                  </div>
                </div>
                            </div>
                            </div>
                            <div className='row'>
    
                            {/*{renderPageHeader(<span>{ts('Saved Campaigns List',this.props.userLogin.language)} <Badge variant='warning ssstitle'>{this.state.activeCompany ? this.state.activeCompany.companyName : ''}</Badge></span>)}*/}
                            {this.state.loadingGifts &&
                                <div className='flexcolumn center verticalcenter p-5 fullWidth hint mt-5 mb-4'>
                                    {/*changed by youssef to meet the selected site requirment*/}
                                    {/*{ts('Loading templates for',this.props.userLogin.language)} {this.state.activeCompany ? this.state.activeCompany.companyName : ''}*/}
                                    {ts('Loading gifts for',this.props.userLogin.language)} {this.props.userLogin.site ? this.props.userLogin.site.companyName : ''}
                                    <Spinner animation="border" className='mt-3' variant="warning" />

                                </div>
                            }
                            </div>
                            {!this.state.loadingGifts &&<div className='row'> <div className='flexrow start wrap mt-2   pt-3 '>
								{this.state.activeGifts.filter(e=>e.id!=null).length>0 && 
							<div className="col-md-12" style={{margin:"30px 0px"}}><center><h6>active</h6></center></div>}
                                {
								
								this.state.activeGifts.map((element) => {
									/*var cats = await G.getData("gifts/categories",[["giftId",element.id]]);
									cats = await cats.data;*/
									console.log(element)
									if(element.id)
                                    	return (this.renderActiveButton(element.id, element))

                                })}
{this.state.expiredGifts.filter(e=>e.id!=null).length>0 && 
							<div className="col-md-12" style={{margin:"30px 0px"}}><center><h6>expired</h6></center></div>}
                                {
								
								this.state.expiredGifts.map((element) => {
									/*var cats = await G.getData("gifts/categories",[["giftId",element.id]]);
									cats = await cats.data;*/
                                    if(element.id)
										return (this.renderExpiredButton(element.id, element))

                                })}
								{this.state.disabledGifts.filter(e=>e.id!=null).length>0 && 
							<div className="col-md-12" style={{margin:"30px 0px"}}><center><h6>disabled</h6></center></div>}
                                {
								
								this.state.disabledGifts.map((element) => {
									/*var cats = await G.getData("gifts/categories",[["giftId",element.id]]);
									cats = await cats.data;*/
									
									if(element.id)
                                    	return (this.renderDisabledButton(element.id, element))

                                })}
                                {this.state.activeGifts.length === 0 && this.state.disabledGifts.length === 0 && this.state.expiredGifts.length === 0 &&
                                    <div className='col-md-12'>
                                    <div className='flexcolumn center verticalcenter p-5 fullWidth cSignInBack boxRadius5'>
                                       {ts(' No Gifts available for',this.props.userLogin.language)} {this.props.userLogin.site ? this.props.userLogin.site.companyName : ''}
                                        <Button onClick={() => { this.getlanguages();this.setState({activeScreen:1});history.push('/Gifts/create') }} variant='success' className='m-4' >Create First Gift</Button>
                                    </div>
                                    </div>
                                }

                            </div>
                            </div>}
                            
                            
                            
                            
                            </section>
                            <MessageBox
                    show={this.state.modalGiftShow}
                    title={this.state.modalSubject?this.state.modalSubject:""}
                    body={
                        <div>
                        <h4 style={{textAlign:"left"}}>Gift info</h4>
                        <ul style={{marginTop:"30px"}}><li>Title: <b>{this.state.selectedRedemption.name}</b></li>
                        <li>Category: <b>{ this.state.giftCategory.map(el=>el+" | ")}</b></li>                        
                        <li>Description: <b>{this.state.selectedRedemption.description}</b></li>
                                
                                <li>Start date: <b>{td(dateFormat(this.state.selectedRedemption.startdate,"mmm dd, yyyy"), this.props.userLogin.language)}</b></li>
                                <li>End date: <b>{td(dateFormat(this.state.selectedRedemption.enddate,"hh:mm tt"), this.props.userLogin.language)}</b></li>
                                <li>Status: <Badge variant={this.state.selectedRedemption.enabled==1?'primary':'danger'} style={{backgroundColor:this.state.selectedRedemption.enabled==1?'#3FCAE0':'lightgray'}} className=' remarks'>
{this.state.selectedRedemption.enabled==1?'Active':'Disabled'}
</Badge></li>
<li>Number of required tokens: <b>{this.state.selectedRedemption.tokensvalue?this.state.selectedRedemption.tokensvalue:ts2("No limit", this.props.userLogin.language)}</b></li>
<li>Usage limit: <b>{this.state.selectedRedemption.limitpergift?this.state.selectedRedemption.limitpergift:ts2("No limit", this.props.userLogin.language)}</b></li>
<li>Remaining usage: <b>{this.state.selectedRedemption.limitpergift?(this.state.selectedRedemption.limitpergift - this.state.giftRedeems.length>=0?this.state.selectedRedemption.limitpergift - this.state.giftRedeems.length:0):ts2("No limit", this.props.userLogin.language)}</b></li>
<li>Number of customers who redeemed: <b>{this.state.giftRedeems.length}</b></li>
                                </ul>
                                <h4 style={{textAlign:"left", marginTop:"30px"}}>Customer info</h4>
                                <ul style={{marginTop:"30px"}}>
                                <li>Customer name: <b>{this.state.selectedRedemption.firstName} {this.state.selectedRedemption.lastName}</b> <a onClick={()=>{window.location.href='/ProfileManagement/customers/edit?id=' + this.state.selectedRedemption.customerid}} style={{color:"#0070FA", cursor:"pointer"}}>view profile</a></li>
<li>Customer email: <b>{this.state.selectedRedemption.emailAddress}</b></li>

                                </ul>
                                {this.state.selectedRedemption.customeralerts && this.state.selectedRedemption.customeralerts.length>0 && <>
                                    <h5 style={{textAlign:"left", marginTop:"30px"}}>Customer alerts</h5>
                                    <ul style={{marginTop:"10px"}}>
                                        {this.state.selectedRedemption.customeralerts.map(el=>{
                                            return(
                                                <li>{el.description}</li>
                                            )
                                        })}
                                    </ul>
                                </>}
                                <Button variant="success" style={{marginTop:"50px", width:"150px"}} onClick={()=>{this.redeemGift()}}>{ts("Redeem Gift", this.props.userLogin.language)}</Button>
                                </div>
                    }
                    onHide={() => { this.setState({ modalGiftShow: false }) }}
                />  
                            <MessageBox
                    show={this.state.redeemModalShow}
                    title="Redeem Gift"
                    body={
                        <div>
                            <div className='row'>
                            <div className="col-md-8">
                            {G.renderTextField("Enter gift code here:","text", "enter gift code here", this.handleChange, fields, errors, null,'',false,this.props.userLogin.language, true, "giftredeemcode")}
                            </div>
                            <div class="col-md-4" style={{position:"relative"}}>
                                <Button variant='success' onClick={async()=>{
                                    if(this.state.fields.giftredeemcode)
                                    {
                                        var result = await G.getData("customergiftcode/query",[["filter","code='"+this.state.fields.giftredeemcode+"'"], ["siteid",this.props.userLogin.site.id]]);
                                        result = await result.data;
                                        if(result.length>0)
                                        {
                                            this.setState({ redeemModalShow: false, redeemCustomerid:result[0].customerid });
                                            var gift = await G.getData("gifts/query",[["filter","id=" + result[0].giftid]])
                                            gift = await gift.data
                                            gift[0].customerid = result[0].customerid
                                            this.showRedeemedGift(gift[0])
                                            //show gift details
                                        }
                                        else{
                                            
                                                this.setState({redeemModalShow:false, giftresult:ts2("Gift code not found", this.props.userLogin.lanauge), giftResultModalShow:true})
                                        }
                                    }
                                    else{
                                        this.state.errors["giftredeemcode"] = "This field is required";
                                        this.setState({errors:this.state.errors});
                                    }
                                }}  style={{position:"absolute", bottom:"17px"}}>{ts("Search", this.props.userLogin.language)}</Button>
                            </div>
                            </div>
                        </div>
                    }
                    onHide={() => { this.setState({ redeemModalShow: false }) }}
                />   
                       <MessageBox
                    show={this.state.giftResultModalShow}
                    body={<div style={{width:"90%", margin:"auto"}}>
                        <h3 style={{width:"100%", textAlign:"center"}}>{this.state.giftresult}</h3><br/><br/>
                        <center><Button variant="warning" onClick={()=>{this.setState({giftResultModalShow:false})}}>OK</Button></center>
                    </div>}
                    onHide={() => { this.setState({ giftResultModalShow: false }) }}
                />     
                        
                        </>
                    )

                }
				{this.state.activeScreen === 1 && 
					renderPageContainer(
						<section className='content'>
							<div className='row'>
							<div className='col-md-12'>
							<Button className='mb-4 mt-5' variant='warning' onClick={() => { this.setState({activeScreen:0, fields:{}, selectedFile:null, imagelink:''});history.go(-1) }} >{ts('Cancel / Return', this.props.userLogin.language)}</Button>
							</div>
							<div className='col-md-12'>
							<h3>{ts('Gift details',this.props.userLogin.language)}
                            </h3>
							</div>
							<div className='col-md-12' style={{height:"20px"}}></div>
							<div className='col-md-12'>
							<p class="  ssstitle bold  boxTopRadius5 cunlayer  p-2  ">{ts("Gift info",this.props.userLogin.language )} </p>
							</div>
							<div className='col-md-12' style={{height:"20px"}}></div>
							<div class="col-12 col-sm-6">
<div class="card card-primary card-outline card-tabs">
<div class="card-header p-0 pt-1 border-bottom-0">
<ul class="nav nav-tabs" id="custom-tabs-two-tab" role="tablist">
<li class="pt-2 px-3"><h6 class="card-title" style={{margin:"0px"}}>Entry by language</h6></li>
{
	this.state.languagesList.map((elem)=>{
		return <li class="nav-item">
<a class={elem.code == "fr"?"nav-link active":"nav-link"} id={"custom-tabs-two-" + elem.code + "-tab"} data-toggle="pill" href={"#custom-tabs-two-" + elem.code} role="tab" aria-controls={"custom-tabs-two-" + elem.code} aria-selected="true">{elem.code}</a>
</li>
	})
}
</ul>
</div>
<div class="card-body">
<div class="tab-content" id="custom-tabs-two-tabContent">
	{
		this.state.languagesList.map((elem)=>{
			return <div class={elem.code == "fr"?"tab-pane fade show active":"tab-pane fade"} id={"custom-tabs-two-" + elem.code} role="tabpanel" aria-labelledby={"custom-tabs-two-"+elem.code+"-tab"}>
				{G.renderTextField("Title", 'text', "enter gift title here", (elem.code == "fr"?this.handleLanguageChange:this.handleChange), fields, errors, null, '',false, this.props.userLogin.language, true,elem.id + "_name",this.onBlur)}
				{G.renderTextArea("Description", 'textarea', "enter gift description here", (elem.code == "fr" ?this.handleLanguageChange:this.handleChange), fields, errors, null, '',false, this.props.userLogin.language, true,elem.id + "_description",this.onBlur)}
			</div>
		})
	}

</div>
</div>

</div>
</div>

<div className='col-md-12' style={{height:"20px"}}></div>
							<div className='col-md-12'>
							<p class="  ssstitle bold  boxTopRadius5 cunlayer  p-2  ">{ts("Gift rules",this.props.userLogin.language )} </p>
							</div>
                            <div className='col-md-12' style={{height:"20px"}}></div>
<div class='col-md-4'>
<div class="form-group">
 <label for="exampleInputFile">Image</label>
<div class="input-group">
<div class="custom-file">
<input type="file" onChange={this.imagechangeHandler} class="custom-file-input" id="icon" name="icon"/>
<label class="custom-file-label" for="exampleInputFile">Choose file</label>
</div>
</div>





</div>
{this.state.imagelink && <img src={this.state.imagelink} style={{width:"150px"}}/>}
</div>
							<div className='col-md-12' style={{height:"20px"}}></div>
							<div className='col-md-6'>
							<label>Category</label>
								<Select ref={this.selectInputRef} menuPortalTarget={document.body} isClearable={true}
       value={this.state.fields["category"]}    
    closeMenuOnSelect={false}
    isMulti
    styles={colourStyles}
    options={this.state.giftCategoryOptions}
	id="category" name="category" onChange={(e)=>this.handleSelectChange("category", e)}
  />
  {this.state.errors['category'] && <div className='remarks notValidColor'>{this.state.errors['category']}</div>}
							</div>
							<div className="col-md-12" style={{height:"20px"}}></div>
							<div class="form-group col-md-3">
                  <label>Start date</label>
                  {
                      this.state.fields["startdate"] &&
                      
                        <DatePicker  name="startdate" oneTap={true} onSelect={(value)=>{this.handleDateChange("startdate",value)}} closeMenuOnSelect={true} closeOverlay="true" defaultValue={new Date(this.state.fields["startdate"])}  onChange={(value)=>this.handleDateChange("startdate",value)} style={{width:"100%",border:this.state.errors['startdate']?"1px solid " + G.errorColor:""}}/>
                  }
                  {  
                      !this.state.fields["startdate"] &&
                        <DatePicker name="startdate" oneTap={true} onSelect={(value)=>{this.handleDateChange("startdate",value)}}  closeMenuOnSelect={true} closeOverlay="true" onChange={(value)=>this.handleDateChange("startdate",value)} style={{width:"100%",border:this.state.errors['startdate']?"1px solid " + G.errorColor:""}}/>

                  }
				  {/*<DatePicker name="startdate" defaultValue={this.state.fields["startdate"]?new Date(this.state.fields["startdate"]):''} closeMenuOnSelect={true}  onSelect={(value)=>this.handleDateChange("startdate",value)} onChange={(value)=>this.handleDateChange("startdate",value)} style={{width:"100%"}}/>*/}
                  {this.state.errors['startdate'] && <div className='remarks notValidColor'>{this.state.errors['startdate']}</div>}
                </div>
				<div class="form-group col-md-3">
                  <label>End date</label>
                  {
                      this.state.fields["enddate"] &&
                      
                        <DatePicker name="enddate" id="enddate" oneTap={true} onSelect={(value)=>{this.handleDateChange("enddate",value)}}  closeMenuOnSelect={true} defaultValue={new Date(this.state.fields["enddate"])}  onChange={(value)=>this.handleDateChange("enddate",value)} style={{width:"100%",border:this.state.errors['enddate']?"1px solid " + G.errorColor:""}}/>
                  }
                  {  
                      !this.state.fields["enddate"] &&
                        <DatePicker name="enddate" oneTap={true} onSelect={(value)=>{this.handleDateChange("enddate",value)}}  closeMenuOnSelect={true} onChange={(value)=>this.handleDateChange("enddate",value)} style={{width:"100%",border:this.state.errors['enddate']?"1px solid " + G.errorColor:""}}/>

                  }
				  {/*<DatePicker name="enddate" closeMenuOnSelect={true}  onSelect={(value)=>this.handleDateChange("enddate",value)} onChange={(value)=>this.handleDateChange("enddate",value)} defaultValue={this.state.fields["enddate"]?new Date(this.state.fields["enddate"]):''} style={{width:"100%"}} />*/}
                  {this.state.errors['enddate'] && <div className='remarks notValidColor'>{this.state.errors['enddate']}</div>}
                </div>
                <div className="col-md-12" style={{height:"20px"}}></div>
                {/*<div class="form-group col-md-3">
				  {G.renderTextField("Code","text", "enter gift code", this.handleChange, fields, errors, null,'',false,this.props.userLogin.language, true, "code")}
                </div>	*/}			
				
				<div class="form-group col-md-3">
				  {G.renderTextField("needed tokens","number", "enter number of tokens", this.handleChange, fields, errors, null,'',false,this.props.userLogin.language, true, "tokensvalue")}
                </div>
                <div class="form-group col-md-3">
				  {G.renderTextField("limit","number", "enter redemption limit", this.handleChange, fields, errors, null,'',false,this.props.userLogin.language, true,"limitpergift")}
                </div>
                <div className="col-md-12" style={{height:"20px"}}></div>
				
				
				<div class="form-group col-md-3">
					<label for="enabled">Status</label>
				  <select name="enabled" id="enabled" style={this.state.errors["enabled"] ? { borderColor: G.errorColor } : {}} onChange={this.handleChange} className="custom-select">
					  <option value="">Please select</option>
                      {this.state.fields["enabled"]=="1" &&<option value="1" selected>Enabled</option>}
                      {this.state.fields["enabled"]!="1" &&<option value="1">Enabled</option>}
                      {this.state.fields["enabled"]=="0" &&<option value="0" selected>Disabled</option>}
                      {this.state.fields["enabled"]!="0" &&<option value="0">Disabled</option>}
				  </select>
                  {this.state.errors['enabled'] && <div className='remarks notValidColor'>{this.state.errors['enabled']}</div>}
                </div>
                
				<div className="col-md-12" style={{height:"20px"}}></div>
				<div className="col-md-3">
				<Button onClick={() => { this.createGift(this.state.giftId)  }} variant='success'  >{ts('Save',this.props.userLogin.language)}</Button>&nbsp;&nbsp;&nbsp;
				<Button variant='warning' onClick={() => { this.setState({activeScreen:0, fields:{}, selectedFile:null, imagelink:''});history.go(-1) }} >{ts('Return', this.props.userLogin.language)}</Button>
				</div>
				<div className="col-md-12" style={{height:"20px"}}></div>
							</div>
						</section>
					)
				}
                {
                    
                    this.state.activeScreen === 2 &&
                    renderPageContainer(
                        
                        <section className='content'>
                            {this.state.customersloading &&
                                <div className='flexcolumn center verticalcenter p-5 fullWidth hint mt-5 mb-4'>
                                    {/*changed by youssef to meet the selected site requirment*/}
                                    {/*{ts('Loading templates for',this.props.userLogin.language)} {this.state.activeCompany ? this.state.activeCompany.companyName : ''}*/}
                                    {ts('Loading',this.props.userLogin.language)}
                                    <Spinner animation="border" className='mt-3' variant="warning" />

                                </div>
                            }
                            {!this.state.customersloading &&
                            <div className='row'>
                            <div className='col-md-12'>
							<Button className='mb-4 mt-5' variant='warning' onClick={() => { this.setState({activeScreen:0, fields:{}, selectedGift:null, giftCategory:[], giftRedeems:[], selectedFile:null});history.go(-1) }} >{ts('Cancel / Return', this.props.userLogin.language)}</Button>
							</div>
                            <div className='col-md-12'>
							<p class="  ssstitle bold  boxTopRadius5 cunlayer  p-2  ">{ts("Gift info",this.props.userLogin.language )} </p>
							</div>
							<div className='col-md-12' style={{height:"20px"}}></div>
                            <div className='col-md-12'> 
                                <ul><li>Title:<b>{this.state.selectedGift.name}</b></li>
                                <li>Category: <b>{ this.state.giftCategory.map(el=>el+" | ")}</b></li>
                                <li>Description: <b>{this.state.selectedGift.description}</b></li>
                                <li>Start date: <b>{this.state.selectedGift.startdate?td(dateFormat(this.state.selectedGift.startdate,"ddd dd, mmm yyyy"), this.props.userLogin.language):td(dateFormat(this.state.selectedGift.datein,"ddd dd, mmm yyyy"), this.props.userLogin.language)}</b></li>
                                <li>End date: <b>{this.state.selectedGift.enddate?td(dateFormat(this.state.selectedGift.enddate,"ddd dd, mmm yyyy"), this.props.userLogin.language):ts2("No limit", this.props.userLogin.language)}</b></li>
                                <li>Status: <Badge variant={this.state.selectedGift.enabled==1?'primary':'danger'} style={{backgroundColor:this.state.selectedGift.enabled==1?'#3FCAE0':'lightgray'}} className=' remarks'>
{this.state.selectedGift.enabled==1?'Active':'Disabled'}
</Badge></li>
<li>Number of required tokens: <b>{this.state.selectedGift.tokensvalue?this.state.selectedGift.tokensvalue:ts2("No limit", this.props.userLogin.language)}</b></li>
<li>Usage limit: <b>{this.state.selectedGift.limitpergift?this.state.selectedGift.limitpergift:ts2("No limit", this.props.userLogin.language)}</b></li>
<li>Remaining usage: <b>{this.state.selectedGift.limitpergift?(this.state.selectedGift.limitpergift - this.state.giftRedeems.length>=0?this.state.selectedGift.limitpergift - this.state.giftRedeems.length:0):ts2("No limit", this.props.userLogin.language)}</b></li>
<li>Number of customers who redeemed: <b>{this.state.giftRedeems.length}</b></li>
                                </ul>
                            </div>
                            <div className='col-md-12' style={{height:"20px"}}></div>
                            <div className='col-md-12'>
							<p class="  ssstitle bold  boxTopRadius5 cunlayer  p-2  ">{ts("List of participants",this.props.userLogin.language )} </p>
							</div>
                            <div className='col-md-12' style={{height:"20px"}}></div>
                            <div className='col-md-12'>
                            <table id="giftexport" className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>{ts2('Action',this.props.userLogin.language)}</th>
                                        <th>{ts2('Date',this.props.userLogin.language)}</th>
                                        <th>{ts2('Time',this.props.userLogin.language)}</th>
                                        <th>{ts2('Gift name',this.props.userLogin.language)}</th>
                                        <th>{ts2('Category',this.props.userLogin.language)}</th>
                                        <th>{ts2('Customer name',this.props.userLogin.language)}</th>
                                        <th>{ts2('Customer email',this.props.userLogin.language)}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {
                                    this.state.giftRedeems.map(item=>{
                                        return (
                                            <tr>
                                                <td>
                                                <Badge variant="success"  className='handCursor remarks' style={{backgroundColor:"#1A98AC"}} onClick={()=>{this.state.selectedRedemption = item; this.openModal()}}>
View Details
</Badge>
                                                </td>
                                                <td>{td(dateFormat(item.datein,"mmm dd, yyyy"), this.props.userLogin.language)}</td>
                                                <td>{td(dateFormat(item.datein,"hh:mm tt"), this.props.userLogin.language)}</td>
                                                <td>{this.state.selectedGift.name}</td>
                                                <td>{ this.state.giftCategory.map(el=>
                                                    {
                                                       return( <Badge variant="primary" style={{backgroundColor:"rgba(63, 202, 224, 0.19)", marginLeft:"10px", color:"black"}} className=' remarks'>
{el}
</Badge>)
                                                    }
                                                    )}
                                                </td>
                                                <td>{item.firstName} {item.lastName}</td>
                                                <td>{item.emailAddress}</td>
                                            </tr>
                                        )
                                    })
                                }
                                
                                    </tbody>
                                    </table>
                            </div>
                            <div className='col-md-12' style={{height:"20px"}}></div>
                            <div className='col-md-12'>
							<Button className='mb-4 mt-5' variant='warning' onClick={() => { this.setState({activeScreen:0, fields:{}, selectedGift:null, giftCategory:[], giftRedeems:[]});history.go(-1) }} >{ts('Cancel / Return', this.props.userLogin.language)}</Button>
							</div>
                            </div>
     }
     <MessageBox
                    show={this.state.modalShow}
                    
                    body={
                        <div>
                        <h4 style={{textAlign:"center"}}>Details</h4>
                        <ul style={{marginTop:"50px"}}><li>Title: <b>{this.state.selectedGift.name}</b></li>                        
                        <li>Description: <b>{this.state.selectedGift.description}</b></li>
                                <li>Category: <b>{ this.state.giftCategory.map(el=>el+" | ")}</b></li>
                                <li>Redemption date: <b>{td(dateFormat(this.state.selectedRedemption.datein,"mmm dd, yyyy"), this.props.userLogin.language)}</b></li>
                                <li>Redemption time: <b>{td(dateFormat(this.state.selectedRedemption.datein,"hh:mm tt"), this.props.userLogin.language)}</b></li>
                                <li>Customer name: <b>{this.state.selectedRedemption.firstName} {this.state.selectedRedemption.lastName}</b></li>
<li>Customer email: <b>{this.state.selectedRedemption.emailAddress}</b></li>
<li>Paid tokens: <b>{this.state.selectedRedemption.tokens}</b></li>
                                </ul>
                                <center><Button variant="warning" style={{marginTop:"50px", width:"150px"}} onClick={()=>{this.setState({ modalShow: false })}}>Close</Button></center>
                                </div>
                    }
                    onHide={() => { this.setState({ modalShow: false }) }}
                />
                
                        </section>
                        
                    )
                }
               <MessageBox
                    show={this.state.successmodalShow}
                    title={ts("Changes are saved",this.props.userLogin.language)}
                    body={<div><center><Button variant="success" onClick={()=>{this.setState({ successmodalShow: false });}}>OK</Button></center></div>}
                    onHide={() => { this.setState({ modalShow: false }) }}

                />
            </>
        )
    }
}
const mapStateToProps = state => {

    return {
        userLogin: state.SaveLogin.userData
    };
};
const colourStyles = {
    menuPortal: base => ({ ...base, zIndex: 9999 }),
    control: (styles) => ({ ...styles, backgroundColor: 'white' }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      const color = chroma("#9B00FA");
      const disabledcolor = chroma("gray")
      return {
        ...styles,
        backgroundColor: isDisabled
          ? undefined
          : isSelected
          ? "#9B00FA"
          : isFocused
          ? disabledcolor
          : undefined,
        color: isDisabled
          ? '#ccc'
          : isSelected
          ? chroma.contrast(color, 'white') > 2
            ? 'white'
            : 'black'
          : "#9B00FA",
        cursor: isDisabled ? 'not-allowed' : 'default',
  
        ':active': {
          ...styles[':active'],
          backgroundColor: !isDisabled
            ? isSelected
              ? "#9B00FA"
              : "#9B00FA30"
            : undefined,
        },
      };
    },
    multiValue: (styles, { data }) => {
      const color = chroma("#9B00FA");
      return {
        ...styles,
        backgroundColor: "#9B00FA",
        color:"#ffffff"
      };
    },
    multiValueLabel: (styles, { data }) => ({
      ...styles,
      color: "#ffffff",
    }),
    multiValueRemove: (styles, { data }) => ({
      ...styles,
      color: "#ffffff",
      ':hover': {
        backgroundColor: "#9B00FA",
        color: 'white',
      },
    }),
  };
export default connect(
    mapStateToProps
)(Gifts)